import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';

import { styles } from './styles';

const MemberTypeSelect = ({ memberTypes }) => {
	const { control } = useFormContext();

	return (
		<Controller
			name="member_type"
			control={control}
			render={({ field, fieldState: { error } }) => (
				<FormControl variant="filled" sx={styles.field} error={Boolean(error)}>
					<InputLabel id="select-member-type" required>
						Select Renewal Member Type
					</InputLabel>
					<Select labelId="select-member-type" {...field}>
						{memberTypes.map(type => {
							return (
								<MenuItem key={type.id} value={type.member_type}>
									{type.member_type}
								</MenuItem>
							);
						})}
					</Select>
					{Boolean(error?.message) && <Box sx={styles.error}>{error.message}</Box>}
				</FormControl>
			)}
		/>
	);
};

export default MemberTypeSelect;
